<template>
  <div>

    <van-calendar class="calendar" v-model="$store.state.calShow" :round="false" position="top" color="#1875f8"
                  :min-date="minDate" @confirm="onConfirm" :show-title="false" ref="Calendar"/>
    <div class="dateChoice" v-if="dateList[dateNow].yearMonth">
      <div class="YM">
        <div>{{ dateList[dateNow].yearMonth }}</div>
      </div>


      <div class="showDay" id="dateR">
        <div class="dayList" v-if="dateList.length>1" id="dateRBox">
          <div class="dayBox" v-for="(item,index) in dateList"
               :style="'background-color:'+(dateNow === index?'#1875f8':'')" @click="dateClick(index)">
            <div class="week" :style="'color:'+(dateNow === index?'white':'#919bad')">{{ item.week }}</div>
            <div class="day" :style="'color:'+(dateNow === index?'white':'#323440')">{{ item.day }}</div>
          </div>
        </div>
      </div>

    </div>
    <van-tabs style="width: 100%" color="#1875f8" line-width="15px" line-height="3px" title-active-color="#1875f8"
              offset-top="46px" duration="0.5" v-model="active" animated sticky swipeable @change="change">
      <van-tab v-for="(dataS,indexS) in menu" :title="dataS" :title-style="'font-size:15px;'+(active===indexS?'font-weight:border':'')">

        <div class="showBoy">
          <van-loading vertical v-if="loading">加载中...</van-loading>
          <div v-if="newsList[indexS] && !loading">
            <van-empty description="暂无内容" v-if="newsList[indexS].infos.length===0"/>


            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <lazy-component>
                <div class="newsBox van-hairline--bottom" v-for="(itemSS,indexSS) in newsList[indexS].infos"
                     v-if="active===0" @click="goDetail(itemSS)">
                  <div class="newsBoxIn">


                    <div class="newsBell" @click="new Date(dateTime(itemSS.date,itemSS.datetime)).getTime()>=timeNow?$bell(this):null">
                      <svg-icon
                          :icon-class="new Date(dateTime(itemSS.date,itemSS.datetime)).getTime()>=timeNow?'bell':'bellBan'"
                          style="width: 12px;height: 14px"></svg-icon>
                    </div>
                    <div class="newsTime">{{ itemSS.datetime }}</div>
                    <div class="newsCountryImg"><img :src="itemSS.countryImg"
                                                     :onerror="itemSS.country==='中国台湾'||itemSS.country==='中国澳门'||itemSS.country==='中国香港'?flagChina:flagFill">
                    </div>
                    <div class="newsCountry">{{ itemSS.country }}</div>
                    <div class="newsStarImg"><img :src="itemSS.starImg"></div>
                    <div class="newsTitle" :style="'color:'+(itemSS.star>2?'#ff444e':'black')">{{ itemSS.title }}</div>


                    <div class="previous">前值 {{ itemSS.previous }}</div>
                    <div class="consensus">预期 {{ itemSS.consensus }}</div>
                    <div class="actual">公布 {{ itemSS.actual }}</div>


                  </div>
                </div>
              </lazy-component>
              <lazy-component>
                <div class="eventBox van-hairline--bottom" v-for="(itemSS,indexSS) in newsList[indexS].infos"
                     v-if="active===1">
                  <div class="eventBoxIn">
                    <div class="eventBell" @click="new Date(dateTime(itemSS.date,itemSS.datetime)).getTime()>=timeNow?$bell(this):null">
                      <svg-icon
                          :icon-class="new Date(dateTime(itemSS.date,itemSS.datetime)).getTime()>=timeNow?'bell':'bellBan'"
                          style="width: 12px;height: 14px"></svg-icon>
                    </div>
                    <div class="eventTime">{{ itemSS.datetime }}</div>
                    <div class="eventCountryImg">
                      <img :src="'http://cdn.jin10.com/images/flag/'+itemSS.country+'.png'" :onerror="imgInt"
                           style="width: 20px;height: 20px">
                    </div>
                    <div class="eventCountry">{{ itemSS.country }}</div>
                    <div class="eventStarImg">
                      <van-rate
                          v-model="itemSS.star"
                          :size="14"
                          :color="itemSS.isImportant>0?'#ff444e':'gold'"
                          void-icon="star"
                          void-color="#ccc"
                          gutter="2px"
                          readonly
                      />
                    </div>
                    <div class="eventTitle" :style="'color:'+(itemSS.isImportant>0?'#ff444e':'black')">
                      {{ itemSS.contentHtml }}
                    </div>
                  </div>
                </div>
              </lazy-component>
            </van-pull-refresh>
          </div>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
export default {
  name: "calendar",
  data() {
    return {
      active: 0,
      menu: ['数据', '事件'],
      dateList: [],
      dateNow: 30,
      newsList: [],
      loading: false,
      imgInt: 'src="' + require('../../assets/international.png') + '"',
      flagFill: 'src="' + require('../../assets/flagFill.png') + '"',
      flagChina: 'src="http://cdn.jin10.com/images/flag/mini/中国.png"',
      isLoading: false
    }

  },
  computed: {
    screenWidth() {
      return this.$store.state.screenWidth;
    },
    minDate() {
      return new Date(2020, 0, 1)
    },
    timeNow() {
      return new Date().getTime()
    }
  },
  methods: {
    getNews(time) {
      this.loading = true
      let date = this.$format(time, "yyyyMMdd")
      // this.$get(this.active === 0 ? '/api/calendar' : '/api/events', {date})
      this.$get('http://wap.tubiaojia.com' + (this.active === 0 ? '/calendar' : '/events'), {date})
          .then(res => {
            this.newsList[this.active] = res
            this.loading = false
            this.$forceUpdate();
          }).catch(err => {
        console.log(err)
      })
    },
    getDate(date) {
      let day = 86400 * 1000
      let firstDate = date - (day * 30)
      let lastDate = date + (day * 30)
      for (let i = 0; i < (lastDate - firstDate) / day; i++) {
        this.dateList[i] = {
          yearMonth: this.$format(new Date(firstDate + (day * i)), "yyyy年MM月"),
          week: this.$getWeek(new Date(firstDate + (day * i)).getDay(), 1),
          day: this.$format(new Date(firstDate + (day * i)), "dd"),
          date: new Date(firstDate + (day * i))
        }
      }
      this.$forceUpdate();
    },
    inMiddle(time) {
      let dateR = document.getElementById('dateR')
      let dateRBox = document.getElementById('dateRBox')
      let scrollPosition = dateR.scrollLeft
      let boxPosition = ((42 + 12) * this.dateNow) - dateRBox.clientWidth / 2 + (42 + 12) / 2

      let frame = 25//帧数比

      for (let i = 0; i < frame; i++) {
        setTimeout(function () {
          dateR.scrollLeft = scrollPosition + ((scrollPosition > boxPosition ? -(scrollPosition - boxPosition) : +(boxPosition - scrollPosition)) / frame) * (i + 1)
        }, time / frame * (i + 1))
      }
    },
    dateClick(index) {
      this.getNews(this.dateList[index].date)
      // this.dateNow = 30
      // this.dateNow = index //
      this.$refs.Calendar.reset(this.dateList[index].date)
      this.getDate(new Date(this.dateList[index].date).getTime())//重新获取时间列表


    },
    onConfirm(date) {
      this.getNews(date)
      this.dateNow = 30
      this.$store.state.calShow = false;
      this.getDate(new Date(date).getTime())
      // this.inMiddle(200)
    },
    change() {
      this.getNews(this.dateList[this.dateNow].date)
    },
    dateTime(date, time) {
      let dateTime = date + ' ' + time
      dateTime = dateTime.substring(0, 19);
      dateTime = dateTime.replace(/-/g, '/');
      return dateTime
    },
    onRefresh() {
      this.getNews(this.dateList[this.dateNow].date)
      this.isLoading = false;
    },
    goDetail(item) {
      this.$router.push({
        path: '/calendarDataDetail', query: {
          id: item.cateId,
          actual: item.actual,
          consensus: item.consensus,
          country: item.country,
          countryImg: item.countryImg,
          date: item.date,
          datetime: item.datetime,
          previous: item.previous,
          starImg: item.starImg,
          title: item.title,
        }
      })
    },


  },
  created() {
    this.getDate(new Date().getTime())
  },
  mounted() {
    // this.inMiddle(0)
    this.getNews(new Date())

  },
  updated() {
    this.inMiddle(200)
  },
  watch: {
    screenWidth() {
      this.inMiddle(200)
    }
  }
}
</script>

<style scoped>
.dateChoice {
  width: 100%;
  height: 80px;
  background-color: #f4f5ff;
  z-index: 100;
  position: fixed;
  top: 89px;
}

.YM {
  width: 100%;
  height: 23px;
  font-size: 10px;
  color: #323440;
  display: flex;
  align-items: center;
  justify-content: center;
}

.showDay {
  width: 100%;
  height: 57px;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  /*position: static;*/
  /*-ms-overflow-style: none;*/
  /*overflow: -moz-scrollbars-none;*/
  /*-webkit-user-select: none;*/
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.showDay::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;

}


.showDay::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.showDay::-webkit-scrollbar-button {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar-resizer {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*o内核*/
.showDay .-o-scrollbar {
  -moz-appearance: none !important;
  background: rgba(0, 255, 0, 0) !important;
}

.showDay::-o-scrollbar-button {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-o-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-o-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-o-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-o-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.showDay::-o-scrollbar-resizer {
  background-color: rgba(0, 0, 0, 0);
}

/*IE10,IE11,IE12*/


/*.dayFrame {*/
/*  overflow: hidden;*/
/*  position: relative;*/
/*width: 100%;*/
/*}*/

.dayList {
  height: 57px;
  display: flex;

}

.dayBox {
  width: 42px;
  min-width: 42px;
  height: 44px;
  border-radius: 4px;
  margin: 4px 6px;
  padding: 3px;
  box-sizing: border-box;
}

.week {
  font-size: 12px;
}

.day {
  font-size: 18px;
}

.showBoy {
  width: 100%;
  padding-top: 126px

}

.newsBox {

  background-color: white;

}

.newsBoxIn {
  position: relative;
  margin: 10px 16px;

}


.newsBell {
  position: absolute;
  top: 5px;
}

.newsTime {
  position: absolute;
  color: #585e6a;
  font-size: 11px;
  top: 10px;
  left: 22px;
}

.newsCountryImg {
  position: absolute;
  top: 0;
  left: 58px;
}

.newsCountry {
  position: absolute;
  top: 7px;
  left: 90px;
  color: #585e6a;
  font-size: 13px;
}

.newsStarImg {
  position: absolute;
  top: 8px;
  right: 0;
}

.newsTitle {
  padding-top: 35px;
  text-align: left;
  font-size: 15px;
  font-weight: bolder;
  padding-bottom: 45px;
}

.previous {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: 10px;
}

.consensus {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 45%;
  bottom: 10px;

}

.actual {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 80%;
  bottom: 10px;
}

.eventBox {

  background-color: white;
}

.eventBoxIn {
  position: relative;
  margin-top: 10px;
  margin-left: 16px;
  margin-right: 16px;
}

.eventBell {
  position: absolute;
  top: 5px;
}

.eventTime {
  position: absolute;
  color: #585e6a;
  font-size: 11px;
  top: 10px;
  left: 22px;
}

.eventCountryImg {
  position: absolute;
  top: 7px;
  left: 64px;
}

.eventCountry {
  position: absolute;
  top: 7px;
  left: 90px;
  color: #585e6a;
  font-size: 13px;
}

.eventStarImg {
  position: absolute;
  top: 8px;
  right: 0;
}

.eventTitle {
  padding-top: 35px;
  text-align: left;
  font-size: 15px;
  font-weight: bolder;
  padding-bottom: 20px;
}

</style>
